import type { FunctionComponent } from 'react';
import {
  ConstructKit,
  ConstructKitFoundations,
  MuseoSans,
  v3FoundationsOverride,
} from '@construct-kit/core';
import commercialOverrideTheme from './commercialOverrideTheme';

type Props = {
  darkMode?: boolean;
  foundationsOverride?: (
    baseFoundations: ConstructKitFoundations,
  ) => ConstructKitFoundations;
  fontOverride?: React.ReactNode | null;
  isV4?: boolean;
  children: React.ReactNode;
};

const CommercialKit: FunctionComponent<Props> = ({
  darkMode,
  fontOverride = null,
  foundationsOverride = commercialOverrideTheme,
  isV4 = true,
  children,
}) => (
  <ConstructKit
    foundationsOverride={
      isV4 ? foundationsOverride : v3FoundationsOverride(foundationsOverride)
    }
    darkMode={darkMode}
  >
    {fontOverride || <MuseoSans />}
    {children}
  </ConstructKit>
);

export default CommercialKit;
